<template>
  <!--콘텐츠 영역-->
  <div id="sub_contents" class="sub_contents">
    <a href="#sub_area" id="top_btn"></a>
    <div class="item NewsDK">
      <div class="tit">
        <h3>
          팝업공지
        </h3>
      </div>
      <div class="News_tit News_bottom_p">
        <h4>{{ detail.title }}</h4>

        <p class="day">(생성일 : {{ detail.createdAt | date }})</p>
          <div class="txt News_bottom">
            <h4>게시기간 : {{ detail.startDt | date }} ~ {{ detail.endDt | date }}</h4>
            <h4>링크 url : {{ detail.linkUrl }}</h4>
            <h4>숨김 처리 : {{ detail.bHide ? '숨김' : '노출' }}</h4>
          </div>

          <div class="img" v-if="detail.MAIN_IMG" style="margin-bottom: 50px;">
                  <img :src="detail.MAIN_IMG"  style="width: 700px;"/>
          </div>
      </div>

      <div class="News_btn_area">
        <button class="btn_list" @click="btnGoList">목록</button>
        <button class="btn_list fl mgr10" v-if="isAdmin" @click="btnUpdate">수정</button>
        <button class="btn_list type01 fl" v-if="isAdmin" @click="btnDelete">삭제</button>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
import pm from "../common/protocolManager";
import eventBus from "../common/eventBus";

export default {
  data: () => ({
    message: "BoardDetail.vue",
    isAdmin: false,
    detail: {
      title: "",
      linkUrl: "",
      startDt: "",
      endtDt: "",
      bHide: false,
      files: {}
    },




  }),
  methods: {
    checkAdmin() {
      let url = "isAdmin";
      pm.get(url)
        .then(result => {
          console.log("checkAdmin - ok");
          this.isAdmin = true;
        })
        .catch(err => {
          console.log("checkAdmin - err");
          this.isAdmin = false;
          if (localStorage.authToken) {
            localStorage.removeItem("authToken");
          }
        });
    },
    btnUpdate() {
      this.$router.replace({
        path: `/notice/PopupWritePopup`,
        query: {
          id: this.$route.query.id,
        }
      });

    },
    btnGoList() {
      history.back();
    },
    btnDelete() {
      if (confirm("정말 삭제하시겠습니까?")) {
        let url = "popupDelete";
        let params = {
          id: this.$route.query.id
        };
        pm.post(url, params)
          .then(result => {
            alert("삭제되었습니다.");
            this.$router.replace("/notice/popupList");
          })
          .catch(err => {
            alert("삭제 실패. 관리자에게 문의해주세요.");
          });
      }
    },
    reqDetail() {
      let url = `popupDetail?id=${this.$route.query.id}`;

      pm.get(url)
        .then(result => {
          this.detail = result.detail;

          if (this.detail.files != undefined) {
            if (this.detail.files && this.detail.files.popupImage && this.detail.files.popupImage.length) {
              this.detail.MAIN_IMG =
                pm.NAS_URL + this.detail.files.popupImage[0].filename;
            }
          }
        })
        .catch(err => {
        });
    }
  },
  computed: {
    IS_MOBILE() {
      return this.$root.$data.isMobileMode;
    }
  },
  destroyed() {
    eventBus.$off("EVENT_CHANGE_POPUP_DETAIL");
  },
  created() {
    this.reqDetail();
    if (localStorage.authToken) {
      this.checkAdmin();
    }

    eventBus.$on("EVENT_CHANGE_POPUP_DETAIL", () => {
      this.reqDetail();
    });
  }
};
</script>



// WEBPACK FOOTER //
// src/components/sub02/PopupDetail.vue